"use client";

import { AlertCircle, RefreshCcw } from "lucide-react";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error("CMS error boundary:", error);
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg-page p-8">
      <div className="max-w-md rounded-lg border border-border-default bg-bg-card p-6 shadow-sm">
        <div className="flex items-start gap-3">
          <AlertCircle className="size-5 shrink-0 text-error" />
          <div className="flex-1 space-y-2">
            <h1 className="font-display text-lg font-semibold">Bir şeyler ters gitti</h1>
            <p className="text-sm text-text-secondary">
              CMS bu sayfada bir hata yakaladı. Tekrar denemek için butonu kullan.
            </p>
            {error?.digest ? (
              <p className="font-mono text-[10px] text-text-tertiary">digest: {error.digest}</p>
            ) : null}
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <Button onClick={reset}>
            <RefreshCcw className="mr-2 size-4" />
            Yeniden dene
          </Button>
        </div>
      </div>
    </div>
  );
}
